import { merge } from 'lodash';
import { makeStyles } from 'tss-react/mui';
import { dflexJustifyCenter, footerBtn, footerSection, tableGrid } from '../../../assets/styles/css-classes';
import CssVariables from '../../../assets/styles/css-variables';
export default makeStyles()((theme, props, classes) => ({
    roleDetailHeader: {
        backgroundColor: `${CssVariables.searchButtonBackground}BF`,
        color: CssVariables.white,
        padding: '0px 20px',
        height: 63,
        display: 'flex',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    roleDetailBackButton: {
        background: 'transparent',
        color: CssVariables.white,
        fontSize: 14,
        fontWeight: 'bold',
        border: 'none',
        fontFamily: "'Open Sans', sans-serif",
        cursor: 'pointer'
    },
    container: {
        flex: 1,
        border: '1px solid #E4E4E4',
        borderRadius: '8px',
        backgroundColor: CssVariables.white,
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 5,
        [theme.breakpoints.down('lg')]: {
            marginLeft: 0,
        }
    },
    tabsRoot: {
        '& .cf-role-detail-page-tabs-indicator': {
            height: 5
        },
        '& .cf-role-detail-page-tab': {
            textTransform: 'inherit',
            fontSize: 12,
            color: '#222222',
            '&.Mui-selected': {
                backgroundColor: '#F5F5F5',
                color: CssVariables.primaryMain,
                fontSize: 12,
                fontWeight: 600,
            },
        }
    },
    tabPanel: {
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
        paddingBottom: '0px !important',
        flex: 1,
        border: 0,
        '& .panelWrapper': {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
        '& .panelContainer': {
            display: 'flex',
            flex: '1 100%',
            '& .tabPanelHeader': {
                display: 'flex',
                height: 34,
                justifyContent: 'space-between',
                paddingLeft: 17,
                paddingRight: 8,
                '& .cf-tab-panel-header-title': {
                    marginTop: 'auto',
                    fontSize: 14,
                    fontWeight: 800,
                    color: '#222222',
                    opacity: 1,
                }
            },
            '& .gridSection': {
                padding: 10,
                marginTop: 4,
                borderTop: '1px solid #DEDEDE',
                height: 'calc(100% - 40px)',
                overflow: 'hidden',
                '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-checkboxInput': {
                    display: 'none',
                },
                '& .MuiDataGrid-cellCheckbox': {
                    opacity: 0.5,
                    pointerEvents: 'none'
                },
                '& .editMode': {
                    '& .MuiDataGrid-cellCheckbox': {
                        opacity: 1,
                        pointerEvents: 'all'
                    }
                }
            },
        },
    },
    enabledPermissions: {
        height: '100%',
        flex: '0 0 100%',
        [`& .${classes.permissionList}`]: {
            '& .add-permission-label': {
                padding: '20px 0 0 40px',
                color: '#BBBBBB',
                fontSize: 14,
                fontWeight: 'bold'
            }
        },
        [`&.${classes.editing}`]: {
            flex: '0 0 50% !important'
        }
    },
    morePermissions: {
        flex: 1,
        height: '100%',
        [`& .${classes.permissionList}.edit`]: {
            borderLeft: '1px solid #DEDEDE',
        }
    },
    panelLeftSection: {
        flex: '0 0 100%',
        [`& .${classes.enabledUsers}, .${classes.tplcUsers}`]: {
            height: '100%',
            [`&.${classes.disableUserGrid}`]: {
                opacity: 0.3,
                cursor: 'pointer',
                '& .gridSection': {
                    pointerEvents: 'none',
                }
            },
        },
        [`&.${classes.editing}`]: {
            flex: '0 0 45% !important'
        }
    },
    panelRightSection: {
        display: 'none',
        flex: 1,
        [`&.${classes.editing}`]: {
            display: 'block'
        },
        '& .gridSection': {
            borderLeft: '1px solid #DEDEDE'
        },
        '& .RoleDetailsEnabledUsersMoreUsersDataGrid': {
            height: 'calc(100% - 68px) !important'
        }
    },
    enabledUsers: {},
    tplcUsers: {},
    disableUserGrid: {},
    editing: {},
    rightSectionTypography: {
        fontSize: 14,
        color: '#222222',
    },
    searchInput: {
        '&.cf-search-input .MuiInputLabel-root': {
            fontSize: 12,
            color: '#BBBBBB',
        }
    },
    permissionList: {
        paddingLeft: '10px !important',
        paddingRight: '10px !important',
        height: 'calc(100% - 38px)',
        overflow: 'auto',
        borderTop: '1px solid #DEDEDE',
        marginTop: 4,
        '& .cf-role-detail-list-item': {
            '&:first-child': {
                borderTop: '1px solid #F4F4F4'
            },
            '&.disabled-permission': {
                opacity: 0.5,
            },
            borderBottom: '1px solid #F4F4F4',
            borderLeft: '1px solid #F4F4F4',
            borderRight: '1px solid #F4F4F4',
            padding: 0,
            '& .cf-role-detail-list-item-icon': {
                borderRight: '1px solid #E4E4E4',
                minWidth: 0,
                height: '100%',
                backgroundColor: '#fff',
                '& .cf-role-detail-list-item-checkbox': {
                    '& .MuiSvgIcon-root': {
                        fontSize: 27
                    }
                }
            },
            '& .MuiListItemText-root': {
                padding: 10,
                margin: 0,
                backgroundColor: '#fff',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                '& .MuiListItemText-primary': {
                    fontSize: 14,
                },
                '& .MuiListItemText-secondary': {
                    fontSize: 12,
                },
            },
        },
        [`& .${classes.subPermissions}`]: {
            paddingLeft: 30,
            '&.disabled-permission': {
                opacity: 0.5,
            }
        }
    },
    subPermissions: {},
    tabHeader: {
        display: 'flex',
        borderBottom: '1px solid #DEDEDE',
    },
    backButton: {
        borderRadius: 0,
        margin: 0,
        fontSize: 17,
        padding: '6px 12px',
        borderRight: '1px solid #DEDEDE',
        color: '#222222',
    },
    formButtonSection: merge(Object.assign({}, dflexJustifyCenter), Object.assign({}, footerSection), {}),
    formButton: merge(Object.assign({}, footerBtn), {}),
    gridRoot: merge(Object.assign({}, tableGrid), {
        '& .MuiDataGrid-row .MuiDataGrid-cell:first-of-type': {
            borderRight: 'unset !important',
        },
        height: '100%'
    }),
}));
//# sourceMappingURL=styles.js.map